import AxiosServices from "./AxiosService";

const Auth = new AxiosServices();


class StudentProgress {

    GetStudentProgress = async () => {
        return Auth.get('/progress/dashboard')
    };

    GetStudentProgressByCourse = async (courseId) => {
        return Auth.get(`/progress/course/${courseId}`)
    };

    UpdateVideoProgress = async (videoId, progress) => {
        return Auth.put(`/progress/video/${videoId}`, progress)
    };

    UpdateCompletedVideo = async (videoId) => {
        return Auth.put(`/progress/video/${videoId}/complete`)
    };

    GetVideoProgressById = async (videoId) => {
        return Auth.get(`/progress/video/${videoId}`)
    };


}

export default StudentProgress

